import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ab0c67b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-operat-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_3 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        "label-position": "right",
        "label-width": "150px",
        ref: "form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "分组标签" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_table, {
                border: "true",
                data: _ctx.postData.list,
                style: {"width":"660px"}
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { label: "分组名称" }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_ui_form_item, {
                        style: {"margin":"0"},
                        data: row.name,
                        required: true,
                        showError: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            style: {"width":"100%"},
                            modelValue: row.name,
                            "onUpdate:modelValue": ($event: any) => ((row.name) = $event),
                            placeholder: "请输入等级名"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    align: "center",
                    width: "100"
                  }, {
                    default: _withCtx(({ $index }) => [
                      _createVNode(_component_el_link, {
                        onClick: ($event: any) => (_ctx.removeGroup($index)),
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, [
                (_ctx.postData.list.length < 20)
                  ? {
                      name: "footer",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            onClick: _ctx.addGroup
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("+ 添加分组")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createTextVNode(" (" + _toDisplayString(_ctx.postData.list.length) + "/{20}) ", 1)
                        ])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["data"])
            ]),
            _: 1
          }),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ]),
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 取消")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}